import React from "react";
import { createRoot } from "react-dom/client";
import Application from "./components/Application";

import "./styles.scss";

window.addEventListener("load", () => {
  const container = document.querySelector(".root");
  if (!container) return "Error starting application";
  const root = createRoot(container);
  // Render the React application to the DOM
  return root.render(<Application />);
});
